import { useHistory } from 'react-router-dom';
import DateFormatResolver, { fullDateUsFormat } from '../resolvers/date-format.resolver';
import layoutNames from 'utils/enums/layout-names.enum';

export const alertTypes = {
	PASSWORD_IS_ABOUT_TO_EXPIRE: 'PASSWORD_IS_ABOUT_TO_EXPIRE',
	CALL_SCHEDULED: 'CALL_SCHEDULED',
	CALL_CANCELLED: 'CALL_CANCELLED',
};

export default (closeAlertDropdown) => {
	const history = useHistory();
	const alertPagePathName = `/${layoutNames.portal}/alerts`;

	const resolveAlertLink = (alert) => {
		switch (alert.code) {
			case alertTypes.PASSWORD_IS_ABOUT_TO_EXPIRE:
				history.push(`/${layoutNames.auth}/change-password`);
				break;
			case alertTypes.CALL_SCHEDULED:
				if (alert?.payload?.appointmentId) {
					history.push(`/${layoutNames.portal}/scheduler/call/${alert?.payload?.appointmentId}`);
				}
				break;
			case alertTypes.CALL_CANCELLED:
				history.push(`/${layoutNames.portal}/scheduler`);
				break;
			default:
				if (history?.location?.pathname !== alertPagePathName) {
					history.push(alertPagePathName);
				}
				if (closeAlertDropdown) {
					closeAlertDropdown();
				}
				break;
		}
	};

	const resolveAlertLinkText = (code) => {
		switch (code) {
			case alertTypes.PASSWORD_IS_ABOUT_TO_EXPIRE:
				return 'Click here to change Password';
			case alertTypes.CALL_SCHEDULED:
				return 'Click here to proceed to Call details';
			case alertTypes.CALL_CANCELLED:
				return 'Click here to proceed to Scheduler';
			default:
				return false;
		}
	};

	const resolveAlertMessage = (code, text, payload) => {
		switch (code) {
			case alertTypes.PASSWORD_IS_ABOUT_TO_EXPIRE:
				return text;
			case alertTypes.CALL_SCHEDULED:
				return `You have a call scheduled for ${DateFormatResolver.resolve(payload.startTime, fullDateUsFormat)}`;
			case alertTypes.CALL_CANCELLED:
				return `Call scheduled for ${DateFormatResolver.resolve(payload.startTime, fullDateUsFormat)} was cancelled by the Client`;
			default:
				return false;
		}
	};


	return {
		resolveAlertLink,
		resolveAlertLinkText,
		resolveAlertMessage,
	};
};
